import React from 'react';

interface JotFormProps {
    // formId: string;
    className?: string;
}

const JotForm: React.FC<JotFormProps> = ({ className = '' }) => {
    // useEffect(() => {
    //     // Create script element
    //     const script = document.createElement('script');
    //     script.src = `https://form.jotform.com/jsform/${formId}`;
    //     script.async = true;
    //     script.type = 'text/javascript';

    //     // Append script to document
    //     document.body.appendChild(script);

    //     // Cleanup function
    //     return () => {
    //         document.body.removeChild(script);
    //     };
    // }, [formId]);

    return (
        <div className={`w-full ${className}`}>
            {/* <p className = "font-bold max-sm:text-xl text-2xl text-white p-4 max-sm:p-2">Full Program + SB $200</p> */}
            <iframe
                id={`JotFormIFrame-251531668449869`}
                title="JotForm1"
                allowTransparency={true}
                allowFullScreen={true}
                allow="geolocation; microphone; camera"
                src={`https://form.jotform.com/${251531668449869}`}
                frameBorder="0"
                style={{
                    minWidth: '100%',
                    height: '578px',
                    border: 'none',
                }}
                scrolling="no"
            />
            {/* <p className = "font-bold max-sm:text-xl text-2xl text-white p-4 max-sm:p-2">SB only form $100</p>
            <iframe
                id={`JotFormIFrame-260111488032851`}
                title="JotForm2"
                allowTransparency={true}
                allowFullScreen={true}
                allow="geolocation; microphone; camera"
                src={`https://form.jotform.com/${260111488032851}`}
                frameBorder="0"
                style={{
                    minWidth: '100%',
                    height: '578px',
                    border: 'none',
                }}
                scrolling="no"
            /> */}
        </div>
    );
};

export default JotForm; 